import { useState } from "react";
import LegalRegistrationFields, { EMPTY_LEGAL_REGISTRATION } from "src/components/legal-acceptance/legal-registration-fields";
import type { ProviderLegalRegistration } from "src/types/platform-legal";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  Grid,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ProfilesAccordion } from "src/components/profiles-accordion";

interface Props {
  open: boolean;
  onClose: () => void;
  onCreate?: (legal: ProviderLegalRegistration[]) => Promise<void>;
  partnerProfiles: any[]; // Replace `any` with the actual type
  checkboxStates: any; // Replace with your type
  handleCheckboxChange: (id: number) => void; // Adjust type based on your logic
}

export default function NewRoleDialog({
  open,
  onClose,
  onCreate,
  partnerProfiles,
  checkboxStates,
  handleCheckboxChange,
}: Props) {
  const { t } = useTranslation();
  const [legal, setLegal] = useState(EMPTY_LEGAL_REGISTRATION);
  const [saving, setSaving] = useState(false);
  const [failed, setFailed] = useState(false);
  const types = checkboxStates.filter((item: any) => item.checked).map((item: any) => item.identifier);

  return (
    <Dialog maxWidth="md" open={open} scroll="body">
      <DialogTitle>{t("create_new_profiles")}</DialogTitle>
      <DialogContent>
        {partnerProfiles.map((partnerProfile, index) => (
          <ProfilesAccordion
            key={partnerProfile.id}
            profile={partnerProfile}
            index={index}
            checkboxStates={checkboxStates}
            handleCheckboxChange={handleCheckboxChange}
          />
        ))}
        <LegalRegistrationFields providerTypes={types} onChange={setLegal} />
        {failed && <Alert severity="error">{t("platform_legal_error")}</Alert>}
      </DialogContent>
      <DialogActions>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Button onClick={onClose} variant="outlined" color="inherit">
              {t("cancel")}
            </Button>
          </Grid>

          <Grid item textAlign={"right"} xs={6}>
            <Button
              disabled={saving || !legal.valid || !types.length}
              onClick={async () => { setSaving(true); setFailed(false); try { await onCreate?.(legal.provider_legal_registrations); } catch { setFailed(true); } finally { setSaving(false); } }}
              variant="contained"
              color="secondary"
              size="medium"
            >
              {t("create")}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
